/* eslint-disable */
import React, { useState } from 'react';
import type { DefaultTheme } from 'styled-components';
import styled, { useTheme } from 'styled-components';
import { SYS_COLOR_FOREGROUND_SIGNAL_PENDING_DARK } from '@oneaudi/unified-web-common';

enum StarState {
  EMPTY = '#FFFFFF',
  HALF = 'url(#half)',
  FILLED = '#000000',
}

const STAR_FILL_LIST_INIT = [
  StarState.EMPTY,
  StarState.EMPTY,
  StarState.EMPTY,
  StarState.EMPTY,
  StarState.EMPTY,
];

const FiveStarRatingContainer = styled.div`
  display: flex;
`;

const SpanStyled = styled.span`
  margin: 0 2px;
  display: flex;
`;

interface FiveStarRatingProps {
  rating?: number;
}

export const FiveStarRating = ({ rating }: FiveStarRatingProps) => {
  const [starFillList, setStarFillList] = useState<StarState[]>(STAR_FILL_LIST_INIT);
  const isLegacy = process.env.IS_LEGACY;
  const themeContext = useTheme() as DefaultTheme & {
    sys: { color: { canvas: Record<number, string> } };
  };

  React.useEffect(() => {
    if (rating) {
      const newStarFillList = [1, 2, 3, 4, 5].map((value) => {
        if (rating >= value - 0.25) {
          return isLegacy ? StarState.FILLED : SYS_COLOR_FOREGROUND_SIGNAL_PENDING_DARK;
        }
        if (rating >= value - 0.75) {
          return StarState.HALF;
        }
        return isLegacy ? StarState.EMPTY : themeContext.sys.color.canvas[200];
      }) as StarState[];
      setStarFillList(newStarFillList);
    }
  }, [rating]);
  return (
    <FiveStarRatingContainer>
      <svg style={{ width: 0, height: 0 }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <defs>
          <linearGradient id="half" x1="0" x2="100%" y1="0" y2="0">
            <stop
              offset="50%"
              stopColor={isLegacy ? '#000000' : SYS_COLOR_FOREGROUND_SIGNAL_PENDING_DARK}
            />
            <stop
              offset="50%"
              stopColor={isLegacy ? '#FFFFFF' : themeContext.sys.color.canvas[200]}
            />
          </linearGradient>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 23" id="star">
            <path d="M12.252 2L15.42 8.419L22.504 9.449L17.378 14.445L18.588 21.5L12.252 18.169L5.916 21.5L7.126 14.445L2 9.449L9.084 8.419L12.252 2" />
          </symbol>
        </defs>
      </svg>
      {starFillList.map((starState, index) => {
        return (
          <SpanStyled key={index}>
            <svg
              width="20.5"
              height="19.5"
              viewBox="0 0 24 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.252 2L15.42 8.419L22.504 9.449L17.378 14.445L18.588 21.5L12.252 18.169L5.916 21.5L7.126 14.445L2 9.449L9.084 8.419L12.252 2Z"
                stroke={isLegacy ? '#000000' : SYS_COLOR_FOREGROUND_SIGNAL_PENDING_DARK}
                strokeWidth="2px"
                strokeMiterlimit="10"
              />
              <use href="#star" fill={starState} />
            </svg>
          </SpanStyled>
        );
      })}
    </FiveStarRatingContainer>
  );
};
